import { jsx as t } from "react/jsx-runtime";
import { memo as c, useMemo as s, useCallback as u } from "react";
import { Radio as a, Row as h } from "antd";
import { u as i } from "../../../../styled-components.browser.esm-BFmoFexH.js";
import { ColoredElement as m } from "@biron-data/react-components";
import { l as x } from "../../../../dummyModel-DGc8qBEQ.js";
const k = c(function({ value: e, onChange: o }) {
  const p = s(() => Array.from(x.entries()).map(([r, l]) => /* @__PURE__ */ t(g, { value: r, checked: e === r, children: /* @__PURE__ */ t(m, { $color: l }) }, r)), [e]), n = u((r) => {
    o == null || o(r.target.value);
  }, [o]);
  return /* @__PURE__ */ t(f, { onChange: n, value: e, children: /* @__PURE__ */ t(b, { gutter: [4, 4], children: p }) });
}), b = i(h)`
  gap: 4px;
`, f = i(a.Group)`
  // Override ant-radio-group in order to properly align content
  &&& {
    display: flex;
    border: none;
  }
  .ant-radio-button-wrapper {
    padding: 4px;
    border-radius: 4px;
  }

  &&& .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled):first-child {
    border: 1px solid #425FF0;
  }

  gap: 8px;
  width: 100%;
  border: none;
  line-height: 36px;
`, g = i(a.Button)`
  display: flex;
  border: 1px solid var(--border-color-input);
  border-radius: 4px;
  justify-content: center;
  align-items: center;
  line-height: var(--line-height);
  ${({ disabled: d }) => d ? "filter: grayscale(100%) opacity(20%);" : ""}
  height: 42px;
  width: 42px;
  
  &&& .ant-radio-button-wrapper-checked {
    box-shadow: 0 0 0 3px rgba(66, 95, 240, 0.12);
  }
  span {
    width: 100%;
    height: 100%;
  }
  display: flex;
`;
export {
  k as default
};
//# sourceMappingURL=ColorSelector.js.map
